(function(){
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('lx-in'); io.unobserve(e.target);} });
  }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
  function init(){
    var main = document.querySelector('main') || document.body;
    var secs = main.querySelectorAll(':scope > .shopify-section, :scope > div > .shopify-section');
    secs.forEach(function(s, i){
      if (i === 0) return;
      s.classList.add('lx-reveal'); io.observe(s);
    });
    main.querySelectorAll('product-card, .product-card').forEach(function(c, i){
      c.classList.add('lx-reveal-item'); c.style.transitionDelay = ((i % 4) * 0.12) + 's'; io.observe(c);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

(function(){
  var p = window.location.pathname.replace(/\/$/,'');
  if (p !== '' && p !== '/es') return;
  function build(){
    var main = document.querySelector('main'); if(!main) return;
    var first = main.querySelector('.shopify-section'); if(!first || document.querySelector('.lx-marquee')) return;
    var items = ['🚚 Envío gratis a toda Colombia','💵 Pagas al recibir','🛡️ Garantía por defectos de fábrica','⚡ Entrega en 2 a 7 días hábiles','💬 Atención por WhatsApp'];
    var html = ''; for (var r=0;r<4;r++){ items.forEach(function(t){ html += '<span class="lx-marquee__item">'+t+'</span>'; }); }
    var band = document.createElement('div'); band.className='lx-marquee'; band.setAttribute('aria-hidden','true');
    band.innerHTML = '<div class="lx-marquee__track">'+html+'</div>';
    first.insertAdjacentElement('afterend', band);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();
